import { Component, AfterViewInit } from '@angular/core';
import WOW from 'wow.js';
// import { NgwWowService } from 'ngx-wow';

import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'Backseat Trader';

  constructor(private router: ActivatedRoute) {

  }

    ngAfterViewInit(): void {
    new WOW().init();
  }
}
